export default __webpack_public_path__ + "static/media/layout1.73abc02c.jpg";